import { Injectable } from '@angular/core';
import { ApiConnectorService } from '../__api/api-connector.service';
import { FunctionsService } from './functions.service';
import { EventEmitterService } from './event-emitter.service';
import { GuiFlowService } from '../__gui/gui-flow.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const BUDGET_LINK = 'https://comenzar.voyjaleas.com/#/cotizacion/';

@Injectable({
  providedIn: 'root'
})

export class ResolverService {
  
  cache = {};
  loadingObj = {};
  empty = {
    clientDetails: {
      name: null,
      lastname: null,
      lastname2: null,
      birthday: null,
      goal: null,
      uePassport: null,

      address: null,
      phone1: null,
      instagram: null,

      atEurope: null,
      visitedCountries: null
    },
    contactForm : [

    ],
    funnelForm : [

    ],
    clientList: [

    ]
  };
  cachePacks = [
    {
      products: []
    },
    {
      products: []
    },
    {
      products: []
    }
  ];
  // client profile
  currentClientCard;
  private sessionData;
  loadedShopifyStockProducts;

  apiDomain = 'https://dashboard.voyjaleas.com'
  
  constructor(private apiConnector: ApiConnectorService,private eventEmitterService: EventEmitterService,private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,private http: HttpClient) {
    // RESOLVER GETTING RESULT OBJECT
    if (this.eventEmitterService.subsVar==undefined) {    

      this.eventEmitterService.subsVar = this.eventEmitterService.    
      invokeFirstComponentFunction.subscribe((data:any) => {
        this.saveDataToLocalCache(data.cacheLabel,data.obj);
      });     

      this.eventEmitterService.subsVar = this.eventEmitterService.
      invokeGetPackagesAssociated.subscribe((data:any) => {
        this.getProductsPerPackNew(data.records[0].data);
      });

    }else{
      /* this.clientApps = this.resolver.getClientApps().records; */
    }
  }

  isLoading(cacheLabel){
    return this.loadingObj[cacheLabel];
  }

  setIsLoading(cacheLabel,newValue){
    this.loadingObj[cacheLabel] = newValue;
  }

  saveLoadedShopifyStockProducts(products){
    this.loadedShopifyStockProducts = products;
  }

  getLoadedShopifyStockProducts(){
    return this.loadedShopifyStockProducts;
  }

  saveDataToLocalCache(cacheLabel,data){
    this.cache[cacheLabel] = data;
  }

  isResolverLoading(){
    let res = false;
    for(let obj in this.loadingObj){
      if(this.loadingObj[obj]){
        res || this.loadingObj[obj];
      }
    }
    return res;
  }

  resolveList(queryName){
    if(this.getDependency(queryName) && this.getDependency(queryName).records){
      return this.getDependency(queryName).records;
    }else{
      return [];
    }
  }

  getDependency(cacheLabel){
    if(this.cache[cacheLabel]){
      return this.cache[cacheLabel];
    }else{
      return this.empty[cacheLabel];
    }
  }

  async getProductsPerPackNew(packageObjList) {
    
    const packageObjs = JSON.parse(packageObjList);
    const requests = packageObjs.map(pack => {
      // Convert the observable to a promise
      return this.getBackendDataForQueryIdNew('getPackDetails', true, pack.id).toPromise();
    });
  
    try {
      // Wait for all promises to resolve
      const allResponses = await Promise.all(requests);
      // Now all requests are complete, you can process the responses
      allResponses.forEach((response, index) => {
        this.savePackDetails(response, packageObjs[index].id);
      });
    } catch (error) {
      console.error('An error occurred:', error);
      // Handle errors, which are now caught here rather than in each request
    }
  }

  // And in your getBackendDataForQueryId method, ensure that you return an observable that can be converted to a promise:
  getBackendDataForQueryIdNew(queryId, force, param1) {
    //...
    return this.apiConnector.voyjaleasApiRequest(queryId, param1, null, null, null, null);
    // Now the caller can choose to subscribe or convert to a promise
  }

  // NEW FUNCTION TO SUSTITUIT ALL
  getBackendDataForQueryId(queryId,force,param1){
    if(queryId=='get' || queryId == 'GET'){
      this.loadingObj[param1] = true;
    }else{
      this.loadingObj[queryId] = true;
    }
    if(!force && this.cache[queryId]){
      this.loadingObj[queryId] = false;
      return this.cache[queryId];
    }else{
      this.apiConnector.voyjaleasApiRequest(queryId,param1,null,null,null,null)
      .subscribe(
        (response) => {
            if(queryId=='get' || queryId == 'GET'){
              this.cache[param1] = response;
              // Use event emmiter
              this.eventEmitterService.onDependecyResolved(response,param1);
              this.loadingObj[param1] = false;
            }else{
              this.cache[queryId] = response;
              // Use event emmiter
              this.eventEmitterService.onDependecyResolved(response,queryId);
              this.loadingObj[queryId] = false;
            }
            

            },
        (error) => {
          this.loadingObj[queryId] = false;
          }
        );
    }
  }

  GET(tableName,force){
    this.loadingObj[tableName] = true;
    if(!force && this.cache[tableName]){
      this.loadingObj[tableName] = false;
      return this.cache[tableName];
    }else{
      this.apiConnector.simpleQueryId('GET',tableName,null,null,null,null)
      .subscribe(
        (response) => {
            this.cache[tableName] = response;
            // Use event emmiter
            this.eventEmitterService.onDependecyResolved(response,tableName);
            this.loadingObj[tableName] = false;
            },
        (error) => {
          this.loadingObj[tableName] = false;
          }
        );
    }
  }

  // THIS IS A GET THAT IS USED FOR WHEN I NEED TO GET THE VALUE OF THE PROMISE AND GO BACK TO THE CALLER CONTROLLER
  getBackendDataForQueryIdAndReturn(queryId: string, includeDependencies: boolean, selectionId: string | number): Observable<any> {
    let url = this.apiDomain+`/api-dashboard/get/queryHandler.php?queryId=${queryId}`; // Backend API endpoint
    const params = {
      includeDependencies: includeDependencies.toString(),
      selectionId: selectionId.toString()
    };
    url = url + '&queryParam1='+selectionId.toString();
    return this.http.get(url);
    //return this.http.get(url, { params }); // Returns an Observable
  }

  getDashboardData(force){
    this.getBackendDataForQueryId('getClientDashboardData',force,null);
  }

  getUserSessionData(){
    return this.cache['userDashSession'];
  }

  savePackDetails(products,label){
    for(let product of products.records){
      switch(product.package_type){
        case 'basic':
          this.cachePacks[0]['products'] = this.commonFunctions.addProduct(product.product,this.cachePacks[0]['products']);
          break;
        case 'premium':
          this.cachePacks[1]['products'] = this.commonFunctions.addProduct(product.product,this.cachePacks[1]['products']);
          break;
        case 'full':
          this.cachePacks[2]['products'] = this.commonFunctions.addProduct(product.product,this.cachePacks[2]['products']);
          break;
        default:
          break;
      }
    }
  }

  //
  getBugdetLinkAccess(token){
    return this.getBudgetsBaseLink()+token;
  }

  getBudgetsBaseLink(){
    return BUDGET_LINK;
  }

  getClientAppList(force){
    this.getBackendDataForQueryId('getClientAppList',force,null)
  }

  // --------------------------------
  // CLIENT PROFILE

  createClientProfile(obj): Observable<{ id: number | string | null }>{
    
    const url = 'https://api.voyjaleas.com/v1/create/userDashSession';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Client': 'dashboard',
      'X-Api-Key': '12345' // or environment.apiKey
    });

    return this.http.post<{ id: number | string | null }>(url, obj, { headers });
  }

  createClientFollowUp(obj){
    let newObj = {
      status: 'budget',
      notes: '',
      progress: 0,
      FK_ID_clientDetails: this.commonFunctions.getSelectedClientId()
    };
    let historic = {
      operation: 'new clientFollowUp card',
      previousObj: JSON.stringify({}),
      newObj: JSON.stringify(newObj),
      FK_ID_clientDetails: this.commonFunctions.getSelectedClientId()
    };
    this.apiConnector.newDynamicApiRequest('post', 'clientFollowUp', newObj)
    .subscribe(
      (response) => {
        /* this.apiConnector.createHistoric(historic, 'clientFollowUp'); */
      },
      (error) => {
        this.guiFlow.reportError(error,'[post clientFollowUp] @ onboarding-page newDynamicApiRequest');
        window.scroll(0, 0);
      }
    );
  }

  updateClientProfile(editedObj){
    let historic = {
      operation: 'update clientDetails',
      previousObj: {},
      newObj: editedObj,
      FK_ID_clientDetails: null
    };
    this.loadingObj['getClientDetails'] = true;
    this.apiConnector.executePutApiRequest('updateClientDetails',editedObj.id,null,null,null,editedObj)
      .subscribe(
        (response) => {
          let normalized = {
            records: []
          };
          normalized.records.push(response['OK']['records']);
          this.cache['getClientDetails'] = normalized;
          // Use event emmiter
          
          this.eventEmitterService.onDependecyResolved(normalized,'getClientDetails');
          this.loadingObj['getClientDetails'] = false;
          this.guiFlow.reportSuccess('Client details updated 💾');
        },
        (error) => {
          this.guiFlow.reportError(error,'[PUT clientDetails] @ email-inbox newDynamicApiRequest');
          this.loadingObj['getClientDetails'] = false;
        }
      );
  }

  processProfileCreation(response,obj){
    // TO DO - Check if user wants to create followUp
    this.createClientFollowUp(obj);
  }

  getClientDetails(force){
    /* this.('getClientDetails',force,this.apiConnector.getSessionData()['id']); */
    this.getBackendDataForQueryId('getClientDetails',force,this.commonFunctions.getSelectedClientId());
  }

  getCurrentClientCard(){
    return this.currentClientCard;
  }

  getPackageDetailsById(force,packId){
    this.getBackendDataForQueryId('getPackDetails',force,packId);
  }

  getPacksAvailable(force){
    this.GET('package',force);
  }

  delete(obj,queryId){
   /*  this.apiConnector.simpleQueryId(queryId,obj.id,null,null,null,null)
    .subscribe(
      (response) => {
        this.guiFlow.reportSuccess('Deleted');
      },
      (error) => {
        this.guiFlow.reportError(error,'[delete ] @resolver');
      }
    ); */
  }

  registerHistoric(historicObj,message){
    this.apiConnector.createHistoric(historicObj,message);
  }

  setCurrentClientCard(obj){
    this.currentClientCard = obj;
  }

  getClientInteractions(force){
    this.loadingObj['getInteractionXclient'] = true;
  if(!force && this.cache['getInteractionXclient']){
    this.loadingObj['getInteractionXclient'] = false;
    return this.cache['getInteractionXclient'];
  }else{

    /* this.apiConnector.executeApiRequest('getInteractionXclient',this.commonFunctions.getSelectedClientId(),null,null,'getInteractionXclient'+this.commonFunctions.getSelectedClientId(),force)
    .subscribe(
      (response) => {
          this.cache['getInteractionXclient'] = response;
          // Use event emmiter
          this.eventEmitterService.onDependecyResolved(response,'getInteractionXclient');
          this.loadingObj['getInteractionXclient'] = false;
          },
      (error) => {
        this.loadingObj['getInteractionXclient'] = false;
        }
      ); */
    }

  }

  goToProfile(obj){
    /* this.setCurrentClientCard(obj);
    this.commonFunctions.setSelectedClientId(obj.id); */
    this.getClientInteractions(true);
    this.getClientChecklists(true);
    /* this.getClientDetails(true); */
    this.guiFlow.goToPage('profile/edit/'+obj.id);
  }

  getClientChecklists(force){
    /* this.getProcessedChecklists('clientChecklists',force,this.commonFunctions.getSelectedClientId()); */
  }

  getDependencyRecords(queryLabel){
    if(this.getDependency(queryLabel) && this.getDependency(queryLabel).records){
      return this.getDependency(queryLabel).records;
    }else{
      return [];
    }
  }

  saveSessionData(data){
    this.sessionData = data;
  }
  
  resolveDependenciesToStart(){
    /* this.getBackendDataForQueryId('get',true,'clientChat'); */
    /* this.getBackendDataForQueryId('getCalendarEvents',true,null); */
    this.getBackendDataForQueryId('getClientDashboardData',true,null);
    this.isResolverLoading();
  }

  processAnswer(response,success,error,icon){
    icon? icon : icon = '';
    if(response && response.OK){
      if(response.OK.message){
        this.guiFlow.openSimpleSnackBar(response.OK.message,icon);
      }else{
        this.guiFlow.openSimpleSnackBar(success,icon);
      }
    }else{
      if(response && response.KO){
        if(response.KO.message){
          this.guiFlow.openSimpleSnackBar(response.OK.message,icon);
        }else{
          this.guiFlow.openSimpleSnackBar(error,icon);
        }
      }else{
        this.guiFlow.openSimpleSnackBar('⛔️ An error has occured.','error');
      }
    }
  }
  
  genericGet(queryName,queryParam1,queryParam2,force){ 
    this.loadingObj[queryName] = true;
    if(!force && this.cache[queryName]){
      this.loadingObj[queryName] = false;
      return this.cache[queryName];
    }else{
      this.apiConnector.simpleQueryId('get',queryName,queryParam1,queryParam2,null,null)
      .subscribe(
        (response) => {
            this.cache[queryName] = response;
            // Use event emmiter
            this.eventEmitterService.onDependecyResolved(response,queryName);
            this.loadingObj[queryName] = false;
            },
        (error) => {
          this.loadingObj[queryName] = false;
          }
        );
    }
  }

  getCachePacks(){
    return this.cachePacks;
  }

  getProcessedChecklists(queryId,force,param1){

    if(queryId=='get' || queryId == 'GET'){
      this.loadingObj[param1] = true;
    }else{
      this.loadingObj[queryId] = true;
    }
    if(!force && this.cache[queryId]){
      this.loadingObj[queryId] = false;
      return this.cache[queryId];
    }else{
      this.apiConnector.voyjaleasApiRequest(queryId,param1,null,null,null,null)
      .subscribe(
        (response) => {
          let ordered = this.commonFunctions.groupChecklists(response.records);
          this.cache[queryId] = ordered;
          // Use event emmiter
          this.eventEmitterService.onDependecyResolved(ordered,queryId);
          this.loadingObj[queryId] = false;
            },
        (error) => {
          this.loadingObj[queryId] = false;
          }
        );
    }
  }

  clearCache(){
      this.cache = {};
      this.loadingObj = {};
      //this.orderProcessing = {};
    }

}
